
import React from 'react';
import ChartGoal from 'charts/ChartGoal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import currencyConverter from 'utils/currencyConverter'

class Metric extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    function addCommasToNumber(input) {
      return input.replace(/\B(?=(\d{3})+(?!\d))/g, '$&,') + (value.length == 2 ? '.' + value[1] : '')
    }

    const conversion = (typeof (this.props.baseCurrency) != "undefined") && (this.props.baseCurrency != this.props.displayCurrency)
    let value = this.props.value ? this.props.value : 0;

    if (conversion == true && !this.props.noConvert) {
      value = currencyConverter(value, this.props.baseCurrency, this.props.displayCurrency)
    }


    if (typeof value == 'string')
      value = parseFloat(value)

    if (this.props.precision != null && this.props.precision != undefined) {
      value = value.toFixed(this.props.precision);
    }

    if (this.props.commas) {
      value = value.toString().split('.')
      value = addCommasToNumber(value[0])
    }

    value = Number.isFinite(parseFloat(value)) ? value.toString() : ""

    let prefix = this.props.prefix ? this.props.prefix : '';
    let suffix = this.props.suffix ? this.props.suffix : '';
    if (this.props.client == "IWA Wine") {
      prefix = ""
      suffix = "x"
    }


    let finalValue = `${prefix}${value}${suffix}`
    finalValue = finalValue.replace('$-', '-$')

    return (
      <>
        {
          `${finalValue}`
        }
      </>
    )
  }

}

export default Metric;
